import React from "react";
import DealInbox from "../Components/Ambassador/Management/DealInbox";

const AmbassadorAllDealsPage: React.FC = () => <DealInbox mode="all" />;

export default AmbassadorAllDealsPage;
